<script>
	import { createEventDispatcher, onDestroy } from 'svelte';

    export let src;

	const dispatch = createEventDispatcher();
	const close = () => dispatch('close');

	let modal;

	const handle_keydown = e => {
		if (e.key === 'Escape') {
			close();
			return;
		}

		if (e.key === 'Tab') {
			// trap focus
			const nodes = modal.querySelectorAll('*');
			const tabbable = Array.from(nodes).filter(n => n.tabIndex >= 0);

			let index = tabbable.indexOf(document.activeElement);
			if (index === -1 && e.shiftKey) index = 0;

			index += tabbable.length + (e.shiftKey ? -1 : 1);
			index %= tabbable.length;

			tabbable[index].focus();
			e.preventDefault();
		}
	};

	const previously_focused = typeof document !== 'undefined' && document.activeElement;

	if (previously_focused) {
		onDestroy(() => {
			previously_focused.focus();
		});
	}
</script>

<svelte:window on:keydown={handle_keydown}/>

<div class="modal-background" on:click={close}>
    <div id="container">
         <img src={src} class="modal" on:click={close} role="dialog" aria-modal="true" bind:this={modal}>
    </div>
</div>


<style>
 .modal-background {
     display: flex;
     position: fixed;
     top: 0;
     left: 0;
     width: 100vw;
     height: 100vh;
     background: rgba(0,0,0,0.6);
 }

 #container {
     display: block;
     margin: auto;
     cursor: zoom-out;
     width: 90%;
     height: 90%;
 }

 .modal {
     width: 100%;
     height: 100%;
     object-fit: contain;
 }
</style>
